module.exports = __webpack_public_path__ + "static/media/LOGOthree.9d88efb7.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/LOGOthree.png
// module id = 23
// module chunks = 0